module.exports = __webpack_public_path__ + "catalog/items/firesafety/Fire-Extinguisher-Dry-Powder/Fire-Extinguisher-Dry-Powder.svg";